import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { AllCampaignsLoadAction } from '../../domains/allCampaigns/actions.types';
import { CampaignsListLoadMoreFulfilledAction } from '../../domains/allCampaigns/loadMoreAllCampaignsActions.types';

import { AllCampaigns } from './types';
const initialState: AllCampaigns = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const loadMoreFulfilledCampaigns = (state: AllCampaigns, options: CampaignsListLoadMoreFulfilledAction['payload']) => {
  const loadedCampaignIds = state.fulfilled?.[`${options.sortBy}-${options.filterByState}`]?.campaignIds || [];
  const newLoadedCampaignIds = options.entities.sortedCampaigns?.campaignIds || [];
  const newState = {
    ...options.entities.sortedCampaigns,
    campaignIds: [...loadedCampaignIds, ...newLoadedCampaignIds],
  };

  return {
    ...state,
    fulfilled: { [`${options.sortBy}-${options.filterByState}`]: newState },
  };
};

type AllCampaignsActions = AllCampaignsLoadAction | CampaignsListLoadMoreFulfilledAction;

const reducer: Reducer<AllCampaigns, AllCampaignsActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'ALL_CAMPAIGNS.LOAD_PENDING':
      return setPending();
    case 'ALL_CAMPAIGNS.LOAD_FULFILLED':
      return setFulfilled({
        [`${action.payload.sortBy}-${action.payload.filterByState}`]: action.payload.entities.sortedCampaigns,
      });
    case 'ALL_CAMPAIGNS.LOAD_MORE_FULFILLED':
      return loadMoreFulfilledCampaigns(state, action.payload);
    case 'ALL_CAMPAIGNS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
